/**
 * Header component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import Modal from 'Common/Modal';
import { eventSupportType } from 'Types/event';

@injectIntl
export default class Header extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        intl: PropTypes.object.isRequired,
        logo: PropTypes.object,
        name: PropTypes.string,
        supportInfo: eventSupportType,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        logo: {},
        name: '',
        supportInfo: {},
    };

    /**
     * @type {Object}
     */
    state = {
        isMenuOpen: false,
        isModalShown: false,
    };

    showModal = () => {
        this.setState({
            isModalShown: true,
        });
    };

    closeModal = () => {
        this.setState({
            isModalShown: false,
        });
    };

    toggleMenu = () => {
        this.setState(({ isMenuOpen }) => ({
            isMenuOpen: !isMenuOpen,
        }));
    };

    render () {
        const { intl, logo, name, supportInfo } = this.props;
        const { isMenuOpen, isModalShown } = this.state;
        const hasEventWebsite = Boolean(supportInfo.eventUrl);
        const hasSupportHelp = Boolean(supportInfo.url || supportInfo.email || supportInfo.phone);

        if (!logo) {
            return null;
        }

        return (
            <header className="registration-site-header data-nc-container" role="banner">
                <div className={ cx('registration-site-header-mobile-nav-container', { open: isMenuOpen }) }>
                    <div className="registration-site-header-mobile-nav">
                        <nav className="registration-site-header-mobile-nav-links">
                            { hasEventWebsite && <div className="nav-item external">
                                <a
                                    className="registration-site-header-link"
                                    href={ supportInfo.eventUrl }
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FormattedMessage id="registration.links.website"/>
                                </a>
                            </div> }
                            { hasSupportHelp && <div className="nav-item external">
                                <button
                                    className="registration-site-header-link"
                                    onClick={ this.showModal }
                                    type="button"
                                >
                                    <FormattedMessage id="registration.links.help"/>
                                </button>
                            </div> }
                        </nav>
                    </div>
                </div>
                <div className="registration-site-header-left data-nc-container">
                    { (hasEventWebsite || hasSupportHelp) &&
                    <button
                        className="registration-site-header-left-mobile-nav" onClick={ this.toggleMenu } type="button"
                    >
                        <i className={ cx('fas', isMenuOpen ? 'fa-times' : 'fa-bars') }/>
                    </button> }
                </div>
                <div className="registration-site-header-center data-nc-container">
                    <div className="logo-wrapper data-nc-element">
                        <div className="logo-image">
                            <div className="site-image-block">
                                <img
                                    src={ logo.src }
                                    alt={ name }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="registration-site-header-right data-nc-container">
                    <div className="registration-site-header-right-nav primary-nav-wrapper data-nc-element">
                        <nav className="site-navigation" role="navigation">
                            { hasEventWebsite && <div className="nav-item external">
                                <a
                                    className="registration-site-header-link"
                                    href={ supportInfo.eventUrl }
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <FormattedMessage id="registration.links.website"/>
                                </a>
                            </div> }
                            { hasSupportHelp && <div className="nav-item external">
                                <button
                                    className="registration-site-header-link"
                                    onClick={ this.showModal }
                                    type="button"
                                >
                                    <FormattedMessage id="registration.links.help"/>
                                </button>
                            </div> }
                        </nav>
                    </div>
                </div>
                { hasSupportHelp && <Modal
                    close={ this.closeModal }
                    show={ isModalShown }
                    title={
                        intl.formatMessage(
                            {
                                id: 'registration.support.header',
                            },
                        )
                    }
                >
                    <div className="row">
                        { supportInfo.email && <div className="col-12 m-b-10">
                            <span className="fa-lg fa-stack">
                                <i className="fa fa-circle fa-stack-2x"/>
                                <i className="fa fa-envelope fa-stack-1x fa-inverse"/>
                            </span>
                            <a href={ `mailto:${ supportInfo.email }` }>{ supportInfo.email }</a>
                        </div> }
                        { supportInfo.phone && <div className="col-12 m-b-10">
                            <span className="fa-lg fa-stack">
                                <i className="fa fa-circle fa-stack-2x"/>
                                <i className="fa fa-phone fa-stack-1x fa-inverse"/>
                            </span>
                            <a href={ `tel:${ supportInfo.phone }` }>{ supportInfo.phone }</a>
                        </div> }
                        { supportInfo.url && <div className="col-12 m-t-10 text-center">
                            <FormattedMessage id="registration.support.link"/>
                            <a
                                className="m-l-5"
                                href={ supportInfo.url }
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <FormattedMessage id="registration.support.faq"/>
                            </a>
                        </div> }
                    </div>
                </Modal> }
            </header>
        );
    }
}
